import Form from "../../Components/Form";
import TextInput from "../../Components/TextInput";
import {
  addSahraUserGroup,
  editSahraUserGroup,
} from "../../Requests/sahraUserGroupRequests";
import Button from "../../Components/Button";
import { useAppDispatch, useAppSelector } from "../../App/hooks";
import {
  sahraUserGroupsFormValuesChangeHandler,
  setSahraUserGroupsFormValues,
} from "../../Features/SahraUserGroups/sahraUserGroupsSlice";
import { toast } from "react-toastify";
import { packetErrorHandler } from "../../Utils/requestUtils";
import { useState } from "react";
import UsersMultiSelectDropdown from "../../Components/Dropdown/Users/UsersMultiSelectDropdown";
import { IAddEditSahraUserGroupFormValues } from "../../Interfaces/sahraUserGroupsInterfaces";

interface IProps {
  onClose: (saved: boolean) => void;
}

const emptyFormValues = {} as IAddEditSahraUserGroupFormValues;

const AddEditForm = ({ onClose }: IProps) => {
  const formValues = useAppSelector((store) => store.sahraUserGroup.formValues);
  const [loading, setLoading] = useState(false);

  const dispatch = useAppDispatch();

  const onChange = (name: string, value: any) => {
    dispatch(sahraUserGroupsFormValuesChangeHandler({ name, value }));
  };

  const getProperFunction = () => {
    if (formValues.id) return editSahraUserGroup(formValues);
    return addSahraUserGroup(formValues);
  };

  const clickHandler = () => {
    setLoading(true);
    getProperFunction()
      .then((resp) => {
        if (resp.data) {
          toast.success(resp.msg);
          dispatch(setSahraUserGroupsFormValues(emptyFormValues));
          onClose(true);
        } else toast.error(resp.msg);
      })
      .catch(packetErrorHandler)
      .finally(() => setLoading(false));
  };

  const cancelEditHandler = () => {
    dispatch(setSahraUserGroupsFormValues(emptyFormValues));
    onClose(false);
  };

  const checkDisabled = () => {
    if (formValues.name) return false;
    return true;
  };

  return (
    <div className="w-80">
      <Form className="p-2 gap-3">
        <h3>
          {formValues.id ? "ویرایش دسته اکانت" : "اضافه کردن دسته اکانت"}
        </h3>
        <TextInput
          label="نام دسته"
          name="name"
          onChange={onChange}
          value={formValues.name}
        />
        <UsersMultiSelectDropdown
          label="اکانت"
          name="sahraUserIds"
          value={formValues.sahraUserIds}
          onChange={onChange}
        />
        <Button
          text={formValues.id ? "ویرایش" : "اضافه کردن"}
          variant="contained"
          onClick={clickHandler}
          loading={loading}
          disabled={checkDisabled()}
        />
        {formValues.id ? (
          <Button
            text="لغو ویرایش"
            variant="outlined"
            onClick={cancelEditHandler}
          />
        ) : (
          <></>
        )}
      </Form>
    </div>
  );
};

export default AddEditForm;
